/* ============================================================
   YANIKO GOLD — Product page (PDP)
   Gallery + zoom, variant selection, qty, countdown, gift wrap,
   add-to-cart (Shopify AJAX + Dawn drawer), buy now, modals,
   wishlist. Scoped to [data-yg-pdp].
   ============================================================ */
(function () {
  "use strict";

  function init(root) {
    if (!root || root.__ygPdpInit) return;
    root.__ygPdpInit = true;

    var variants = [];
    var dataNode = root.querySelector("[data-variants-json]");
    if (dataNode) { try { variants = JSON.parse(dataNode.textContent); } catch (e) { variants = []; } }
    var optionCount = parseInt(root.getAttribute("data-option-count") || "0", 10);
    var colorIndex = parseInt(root.getAttribute("data-color-index") || "-1", 10);

    /* ---------- Gallery ---------- */
    var main = root.querySelector("[data-main]");
    root.querySelectorAll("[data-thumb]").forEach(function (t) {
      t.addEventListener("click", function () {
        root.querySelectorAll("[data-thumb]").forEach(function (x) { x.classList.remove("is-on"); });
        t.classList.add("is-on");
        var full = t.getAttribute("data-img");
        if (main && full) { main.removeAttribute("srcset"); main.src = full; }
      });
    });
    var stage = root.querySelector("[data-stage]");
    if (stage) stage.addEventListener("click", function (e) {
      if (e.target.closest("[data-zoom]") || e.target === stage || e.target === main) stage.classList.toggle("is-zoom");
    });

    /* ---------- Variant selection ---------- */
    var selected = [];
    root.querySelectorAll("[data-opt]").forEach(function (group) {
      var idx = parseInt(group.getAttribute("data-opt-index"), 10);
      var on = group.querySelector("[data-val].is-on") || group.querySelector("[data-val]");
      if (on) selected[idx] = on.getAttribute("data-val");
    });
    function findVariant() {
      if (!variants.length) return null;
      var m = variants.find(function (v) {
        for (var i = 0; i < optionCount; i++) { if (v.options[i] !== selected[i]) return false; }
        return true;
      });
      if (m) return m;
      if (variants.length === 1) return variants[0]; // single / default-variant products
      return null;
    }
    function syncGallery(v) {
      if (main && v.image) {
        var abs = new URL(v.image, location.href).href;
        if (main.src !== abs) { main.removeAttribute("srcset"); main.src = abs; }
      }
      var thumbs = root.querySelectorAll("[data-thumb]");
      var colorVal = colorIndex >= 0 ? selected[colorIndex] : null;
      thumbs.forEach(function (t) {
        var colors = t.getAttribute("data-colors");
        var show = !colorVal || !colors || colors.split("|").indexOf(colorVal) !== -1;
        t.style.display = show ? "" : "none";
        t.classList.toggle("is-on", v.image && t.getAttribute("data-img") === v.image);
      });
    }
    function updateVariant() {
      var v = findVariant();
      var addBtn = root.querySelector("[data-add-main]");
      var buyBtn = root.querySelector("[data-buy-now]");
      var inquire = root.querySelector("[data-inquiry-open]");
      var idInput = root.querySelector("[data-variant-id]");
      var priceNow = root.querySelector("[data-price-now]");
      var priceOld = root.querySelector("[data-price-old]");
      var priceDisc = root.querySelector("[data-price-disc]");
      var saleBadge = root.querySelector("[data-sale-badge]");
      if (!v) { if (addBtn) { addBtn.disabled = true; addBtn.textContent = "Изберете опция"; } return; }
      if (idInput) idInput.value = v.id;
      syncGallery(v);
      if (priceNow) { priceNow.innerHTML = v.price_str; priceNow.classList.toggle("is-sale", v.on_sale); }
      var priceAlt = root.querySelector("[data-price-alt]");
      if (priceAlt) priceAlt.innerHTML = v.price_alt || "";
      if (priceOld) { priceOld.innerHTML = v.compare_str || ""; priceOld.style.display = v.on_sale ? "" : "none"; }
      if (priceDisc) { priceDisc.textContent = "−" + v.disc + "%"; priceDisc.style.display = v.on_sale ? "" : "none"; }
      if (saleBadge) { saleBadge.textContent = "−" + v.disc + "%"; saleBadge.style.display = v.on_sale ? "" : "none"; }
      var buyRow = root.querySelector(".pdp__buy");
      if (v.available) {
        if (buyRow) buyRow.style.display = "";
        if (addBtn) { addBtn.disabled = false; addBtn.textContent = root.getAttribute("data-add-label") || "Добави в количката"; }
        if (buyBtn) buyBtn.style.display = "";
        if (inquire) inquire.hidden = true;
      } else {
        // sold out: hide qty+add and "buy now", show only the inquiry button
        if (buyRow) buyRow.style.display = "none";
        if (buyBtn) buyBtn.style.display = "none";
        if (inquire) inquire.hidden = false;
      }
    }
    root.querySelectorAll("[data-opt]").forEach(function (group) {
      var idx = parseInt(group.getAttribute("data-opt-index"), 10);
      var label = group.querySelector("[data-opt-val]");
      group.querySelectorAll("[data-val]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          group.querySelectorAll("[data-val]").forEach(function (b) { b.classList.remove("is-on"); });
          btn.classList.add("is-on");
          selected[idx] = btn.getAttribute("data-val");
          if (label) label.textContent = btn.getAttribute("data-val");
          updateVariant();
        });
      });
    });
    updateVariant();

    /* ---------- Quantity ---------- */
    var qtyInput = root.querySelector("[data-qty]");
    var dec = root.querySelector("[data-qty-dec]"), inc = root.querySelector("[data-qty-inc]");
    if (dec) dec.addEventListener("click", function () { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1); });
    if (inc) inc.addEventListener("click", function () { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; });

    /* ---------- Countdown ---------- */
    var cd = root.querySelector("[data-countdown]");
    if (cd && cd.getAttribute("data-ends")) {
      var ends = parseInt(cd.getAttribute("data-ends"), 10) * 1000;
      var dEl = cd.querySelector("[data-cd-d]"), hEl = cd.querySelector("[data-cd-h]"), mEl = cd.querySelector("[data-cd-m]"), sEl = cd.querySelector("[data-cd-s]");
      var timer;
      var tick = function () {
        var diff = ends - Date.now();
        if (diff <= 0) { cd.classList.remove("is-on"); clearInterval(timer); return; }
        var d = Math.floor(diff / 864e5), h = Math.floor(diff % 864e5 / 36e5), m = Math.floor(diff % 36e5 / 6e4), s = Math.floor(diff % 6e4 / 1e3);
        if (dEl) dEl.textContent = (d < 10 ? "0" : "") + d;
        if (hEl) hEl.textContent = (h < 10 ? "0" : "") + h;
        if (mEl) mEl.textContent = (m < 10 ? "0" : "") + m;
        if (sEl) sEl.textContent = (s < 10 ? "0" : "") + s;
      };
      cd.classList.add("is-on"); tick(); timer = setInterval(tick, 1000);
    }

    /* ---------- Cart ---------- */
    function toast(msg) {
      var t = document.querySelector(".yg-toast");
      if (!t) {
        t = document.createElement("div"); t.className = "yg-toast toast"; t.setAttribute("role", "status");
        t.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="m5 13 4 4L19 7"/></svg><span></span>';
        document.body.appendChild(t);
      }
      t.querySelector("span").textContent = msg; t.classList.add("is-on");
      clearTimeout(t.__timer); t.__timer = setTimeout(function () { t.classList.remove("is-on"); }, 2600);
    }
    function openDrawer() {
      var d = document.querySelector("cart-drawer");
      if (d) { if (typeof d.open === "function") d.open(); else d.classList.add("active", "animate"); return true; }
      return false;
    }
    function refreshSections(sections) {
      if (!sections) return;
      Object.keys(sections).forEach(function (k) {
        var parsed = new DOMParser().parseFromString(sections[k] || "", "text/html");
        var bs = parsed.getElementById("cart-icon-bubble"), bd = document.getElementById("cart-icon-bubble");
        if (bs && bd) bd.innerHTML = bs.innerHTML;
        var liveDrawer = document.querySelector("cart-drawer");
        if (!liveDrawer) return;
        var srcDrawer = parsed.querySelector("cart-drawer");
        var ds = (srcDrawer && srcDrawer.querySelector(".drawer__inner")) || parsed.querySelector(".drawer__inner");
        var dd = liveDrawer.querySelector(".drawer__inner");
        if (ds && dd) dd.innerHTML = ds.innerHTML;
        else if (srcDrawer) liveDrawer.innerHTML = srcDrawer.innerHTML;
        // mirror the empty/filled state — Dawn hides the items while the drawer keeps .is-empty
        if (srcDrawer) liveDrawer.classList.toggle("is-empty", srcDrawer.classList.contains("is-empty"));
        else liveDrawer.classList.remove("is-empty");
      });
    }
    function addToCart(then) {
      var v = findVariant();
      if (!v || !v.available) { toast("Изберете наличен вариант"); return; }
      var qty = parseInt(qtyInput && qtyInput.value, 10) || 1;
      var body = { items: [{ id: v.id, quantity: qty }], sections: "cart-drawer,cart-icon-bubble", sections_url: window.location.pathname };
      var gift = root.querySelector("[data-gift]");
      if (gift && gift.checked) body.items[0].properties = { "Подарък": "Да" };
      fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) { toast(res.d && res.d.description ? res.d.description : "Грешка"); return; }
          refreshSections(res.d.sections);
          if (then === "checkout") { window.location.href = "/checkout"; return; }
          openDrawer(); toast("Добавено в количката");
        })
        .catch(function () { toast("Грешка при добавяне"); });
    }
    var addBtn = root.querySelector("[data-add-main]");
    if (addBtn) addBtn.addEventListener("click", function (e) { e.preventDefault(); addToCart(); });
    var buyBtn = root.querySelector("[data-buy-now]");
    if (buyBtn) buyBtn.addEventListener("click", function (e) { e.preventDefault(); addToCart("checkout"); });

    /* ---------- Modals ---------- */
    function bindModal(openSel, modalSel) {
      var m = root.querySelector(modalSel);
      if (!m) return;
      root.querySelectorAll(openSel).forEach(function (b) { b.addEventListener("click", function () { m.classList.add("is-on"); }); });
      m.querySelectorAll("[data-modal-close]").forEach(function (b) { b.addEventListener("click", function () { m.classList.remove("is-on"); }); });
      m.addEventListener("click", function (e) { if (e.target === m) m.classList.remove("is-on"); });
    }
    bindModal("[data-inquiry-open]", "[data-inquiry]");
    bindModal("[data-size-guide]", "[data-sizeguide]");
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") root.querySelectorAll(".modal-scrim.is-on").forEach(function (m) { m.classList.remove("is-on"); });
    });

    /* ---------- Wishlist ---------- */
    var wishBtn = root.querySelector("[data-pdp-wish]");
    if (wishBtn) {
      var KEY = "yg-wishlist";
      var title = root.getAttribute("data-product-title") || "";
      var set;
      try { set = new Set(JSON.parse(localStorage.getItem(KEY) || "[]")); } catch (e) { set = new Set(); }
      if (set.has(title)) wishBtn.classList.add("is-active");
      wishBtn.addEventListener("click", function () {
        var active = !wishBtn.classList.contains("is-active");
        wishBtn.classList.toggle("is-active", active);
        if (active) set.add(title); else set.delete(title);
        try { localStorage.setItem(KEY, JSON.stringify(Array.from(set))); } catch (e) {}
        toast(active ? "Добавено в любими ♥" : "Премахнато от любими");
      });
    }

    /* ---------- Related products (dynamic recommendations) ---------- */
    var recoBox = root.querySelector("[data-pdp-recos]");
    if (recoBox && recoBox.getAttribute("data-url") && !recoBox.__loaded) {
      recoBox.__loaded = true;
      fetch(recoBox.getAttribute("data-url"))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, "text/html");
          var src = doc.querySelector("[data-recos-ready]");
          if (src && src.children.length) {
            recoBox.innerHTML = src.innerHTML;
            var sec = root.querySelector("[data-pdp-recos-section]");
            if (sec) sec.removeAttribute("hidden");
            if (window.__ygRevealIO) {
              recoBox.querySelectorAll(".reveal").forEach(function (el) { window.__ygRevealIO.observe(el); });
            }
          }
        })
        .catch(function () {});
    }
  }

  function boot() { document.querySelectorAll("[data-yg-pdp]").forEach(init); }
  if (document.readyState !== "loading") boot();
  else document.addEventListener("DOMContentLoaded", boot);
  document.addEventListener("shopify:section:load", function (e) {
    if (e.target.querySelectorAll) e.target.querySelectorAll("[data-yg-pdp]").forEach(init);
  });
})();
